import React from 'react';
import ReactDOM from 'react-dom';
import Home from './Home'
import "babel-polyfill";
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Home />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js